import { firestore } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

// Append a notification into the single-doc structure at
// USERS/{uid}/USER_DATA/MY_NOTIFICATIONS using Android-style indexed fields
async function appendNotification(userId, { title, body, type = 'info', image = '', orderId = '', productId = '' }) {
  if (!userId) return;
  try {
    const notifRef = doc(firestore, 'USERS', userId, 'USER_DATA', 'MY_NOTIFICATIONS');
    const snap = await getDoc(notifRef);
    const data = snap.exists() ? (snap.data() || {}) : {};
    const size = Number(data.list_size) || 0;
    const idx = size;

    const update = {
      [`image_${idx}`]: image || '',
      [`title_${idx}`]: title || '',
      [`body_${idx}`]: body || '',
      [`type_${idx}`]: type || 'info',
      [`orderId_${idx}`]: orderId || '',
      [`productId_${idx}`]: productId || '',
      [`readed_${idx}`]: false,
      [`createdAt_${idx}`]: serverTimestamp(),
      list_size: idx + 1,
      // convenience fields for lightweight listeners
      latest_title: title || '',
      latest_body: body || '',
      latest_type: type || 'info',
      latest_orderId: orderId || '',
      latest_productId: productId || '',
      latest_createdAt: serverTimestamp(),
    };

    await setDoc(notifRef, update, { merge: true });
  } catch (e) {
    console.warn('appendNotification failed', e?.message || e);
  }
}

export async function createOrderPlacedNotification(userId, orderId) {
  const title = 'Order placed';
  const body = `Your order ${orderId} has been placed.`;
  return appendNotification(userId, { title, body, type: 'placed', orderId });
}

export async function createOrderStatusNotification(userId, orderId, status, productId) {
  const safeStatus = (status || '').toString();
  const title = 'Order update';
  const body = `Order ${orderId} status: ${safeStatus}`;
  const type = safeStatus.toLowerCase();
  return appendNotification(userId, { title, body, type, orderId, productId });
}
